<template>
  <div class="py-6 w-full px-3">
    <div v-if="plan === 'basic' || plan === 'standard'">
          <h1 class="text-xl text-left font-bold flex mb-4 -mt-2">Performance</h1>
          <div class="w-full border my-1" />
          <ErrorPageAcess />
    </div>
    <div v-else>
    <h1 class="text-xl text-left font-bold flex mb-4 -mt-2">
      Performance
    </h1>
    <div class="w-full border my-1" />
    <Tabs
      class="mt-3"
      :tabs="tabsItems"
      :active-tab="activeTab"
      @currentTab="activateTab($event)"
      :border="true"
    />
    <PerformanceTemplate
      v-if="activeTab === 'Templates'"
    />
    <AppraisalScores
      v-if="activeTab === 'Targets, Ratings & Rankings'"
      @openDescription="showDescription = true"
    />
    <GeneralSettings
      v-if="activeTab === 'Preferences'"
    />

    </div>
  </div>
</template>

<script>
import Tabs from '@scelloo/cloudenly-ui/src/components/tab';
import ErrorPageAcess from "@/modules/Admin/error404";
import AppraisalScores from './AppraisalScores/index';
import PerformanceTemplate from './Template/PerformanceTemplate';
import GeneralSettings from './GeneralSettings';


export default {
  components: {
    Tabs,
    AppraisalScores,
    PerformanceTemplate,
    GeneralSettings,
    ErrorPageAcess,
  },
  data() {
    return {
      activeTab: this.$route.query.activeTab || "Templates",
      kpaModal: false,
      tabsItems: process.env.NODE_ENV === "production" ? [
        "Templates",
        "Targets, Ratings & Rankings",
        "Preferences",
      ] : [
        "Templates",
        "Targets, Ratings & Rankings",
        "Personal Development Plans",
        "Preferences",
      ],
    };
  },
  computed: {
    plan() {
      const result = this.$store.state.subscription ? this.$store.state.subscription.plan : null
      return result
    },
  },

  methods: {
    activateTab(tab) {
      this.activeTab = tab;
      this.$router.push({name: 'PerformanceSettings',
        query: { activeTab: tab }
        }).catch(()=>{});
    }
  }
};
</script>

<style>
.border__dashed
{
  height: 0px;
  margin: 18px 0px;
  border: 1px dashed #878E99;
}
 </style>
